module.exports = __webpack_public_path__ + "static/28-a1aae3f327de77e390ebbd02877e221e.png";